import { render } from "./ReceiptCreate.vue?vue&type=template&id=b738e2e0&scoped=true"
import script from "./ReceiptCreate.vue?vue&type=script&lang=js"
export * from "./ReceiptCreate.vue?vue&type=script&lang=js"

import "./ReceiptCreate.vue?vue&type=style&index=0&id=b738e2e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b738e2e0"]])

export default __exports__